import { atom, type createStore } from 'jotai';

export const ContentGatingStatus = {
	NONE: 'NONE',
	BLOCKED: 'BLOCKED',
} as const;

// Add other types in the future. LITE, USER, etc as an example.
export type ContentGatingStatusType =
	(typeof ContentGatingStatus)[keyof typeof ContentGatingStatus];

interface ContentGatingState {
	detailedPricing: ContentGatingStatusType;
	venuePricing: ContentGatingStatusType;
	availability: ContentGatingStatusType;
}

/** @internal */
export const initialState: ContentGatingState = {
	detailedPricing: 'NONE',
	availability: 'NONE',
	venuePricing: 'NONE',
};

export const detailedPricingContentGateAtom = atom(
	initialState.detailedPricing,
);
export const venuePricingContentGateAtom = atom(initialState.venuePricing);

export const availabilityContentGateAtom = atom(initialState.availability);

export const getContentGatingDataToHydrate = (
	store: ReturnType<typeof createStore>,
) => {
	return {
		detailedPricing: store.get(detailedPricingContentGateAtom),
		venuePricing: store.get(venuePricingContentGateAtom),
		availability: store.get(availabilityContentGateAtom),
	};
};

export const getContentGatingInitialValues = (
	value: ReturnType<typeof getContentGatingDataToHydrate>,
) => {
	const { detailedPricing, availability, venuePricing } = value || {};
	return [
		[
			detailedPricingContentGateAtom,
			detailedPricing || initialState.detailedPricing,
		],
		[venuePricingContentGateAtom, venuePricing || initialState.venuePricing],
		[availabilityContentGateAtom, availability || initialState.availability],
	];
};
